import {Component} from "@angular/core";
import {Header} from "../../layout/header/header";
import {LargeLogoShear} from "../../layout/large-logo-shear/large-logo-shear";

@Component({
  selector: "app-disclaimer",
  templateUrl: "./disclaimer.html",
  imports: [
    Header,
    LargeLogoShear,
  ],
})
export default class Disclaimer {
}
